import React, { Component } from 'react';
import {StyleSheet, Text, View, Animated, Easing, Image, Pressable} from 'react-native';


const fps = 60;
const fpsDuration = 1000/fps;
const fpsPecent = 1/fps;
const MYEPSILON = 0.0001;

class TextReader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      text: this.props.text,
    }

  }

  changeText(newText) {
	  this.setState({text: newText});
  }

  render() {
	  //console.log(this.state.threat)
    return (
        <Text style={styles.actionNumber}>{this.state.text}</Text>
    );
  }
}

const styles = StyleSheet.create({
  actionNumber: {
    fontSize: 20,
    fontFamily: 'Alegreya-Regular',
    color: '#000000',
    minWidth: 50,
    textAlign: 'center',
  },
});

export default TextReader;